import "./styles.scss"
import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { PopupsContext } from "./context"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import PopupsListing from "./containers/listing"
import { TPopups } from "./types"
import PopupDetails from "./containers/details"

export default function Popups({ }: TPopups) {
    return <ContentSectionContainer className="formsContainer">
        <PopupsContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.popups })} element={<PopupsListing />} />
                <Route path={fetchRoute({ route: ERoutes.popupDetails })} element={<PopupDetails />} />
                <Route path={fetchRoute({ route: ERoutes.popupEdit })} element={<PopupDetails />} />

                <Route index path={"/"} element={<PopupsListing />} />
                <Route index path={"/:popupId"} element={<PopupDetails />} />
                <Route index path={"/:popupId/edit"} element={<PopupDetails />} />

            </Routes>
        </PopupsContext.Provider>
    </ContentSectionContainer >
}   